<div class="ap-card {{ cardModifier() }}">
    <div class="ap-card__image-container">
        <img class="ap-card__image" [src]="imageSource()" [alt]="alt()" data-testid="image" />
    </div>
    <div class="ap-card__body" data-testid="body">
        <ng-content></ng-content>
    </div>
</div>
